import React from "react";
import PropTypes from "prop-types";
import StandardModal from "js/components/shared/StandardModal";
import { ChakraFAIcon } from "@/components/ui/Icon";
import { useTranslation } from "react-i18next";

const DeleteAllRulesModal = ({ open, onActions, onClose, rulesCount }) => {
	const { t } = useTranslation();
	return (
		<StandardModal
			size="small"
			header={<div className="DeleteAllRulesModal_Title">{t("policyDrawer.deleteAllRulesModalTitle", { count: rulesCount })}</div>}
			open={open}
			actions={onActions}
			close={onClose}
		>
			<div className="DeleteAllRulesModal_Confirm">{t("policyDrawer.deleteAllRulesConfirm")}</div>
			<div className="DeleteAllRulesModal_Warning">
				<div className="DeleteAllRulesModal_WarningText">
					<ChakraFAIcon icon="fa-exclamation-triangle" variant="solid" className="DeleteAllRulesModal_WarningIcon" />
					{t("policyDrawer.deleteAllRulesPermanent")}
				</div>
				<div className="DeleteAllRulesModal_WarningSubtext">
					{t("policyDrawer.deleteAllRulesSharedWarningLine1")}
					<br />
					{t("policyDrawer.deleteAllRulesSharedWarningLine2")}
				</div>
			</div>
		</StandardModal>
	);
};

DeleteAllRulesModal.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	rulesCount: PropTypes.number,
	onDelete: PropTypes.func,
	onActions: PropTypes.object,
};

export default DeleteAllRulesModal;
